import { CustomPIXIComponent } from 'react-pixi-fiber'
import { Container } from 'pixi.js'
import { Spine } from 'pixi-spine'
import { Loader } from "pixi.js"
const { resources } = Loader.shared

const ANIMATION_SCALE = 1.75
const ANIMATION_TIMESCALE = 1

//CUSTOM REACT-PIXI CLASS
export default CustomPIXIComponent({
  customDisplayObject(props) {
    const container = new Container()

    const spineData = resources['win-feedback'].spineData
    const spine = new Spine(spineData)

    spine.state.timeScale = 0
    spine.visible = false

    container.addChild(spine)

    return container
  },

  customApplyProps(displayObject, oldProps, newProps) {
    const { width, height, level } = newProps
    displayObject.height = height * ANIMATION_SCALE
    displayObject.scale.x = displayObject.scale.y

    const spine = displayObject.children[0]

    displayObject.position.set(width * 0.5, height * 0.5)

    if (level && level !== oldProps.level) {
      spine.state.timeScale = ANIMATION_TIMESCALE
      spine.visible = true

      const animationKey = `level${level + 1}`
      const idleKey = `level${level + 1}_idle`

      spine.state.setAnimation(0, animationKey)
      spine.state.addListener({
        complete: () => {
          spine.state.setAnimation(0, idleKey, true)
        }
      })
    }
  }
}, 'CountUpPanel')
